var ctrl = function($scope, hotkeys, APP) {
  var initializeVars = function() {
    $scope.offsetStart = $scope.pagination.perPage * ($scope.pagination.page - 1) + 1;

    $scope.offsetEnd = $scope.pagination.perPage * $scope.pagination.page;
    if ($scope.offsetEnd > $scope.pagination.totalEntries) {
      $scope.offsetEnd = $scope.pagination.totalEntries;
    }
  };

  if ($scope.pagination) {
    initializeVars();
  }

  $scope.nextPage = function() {
    if (!$scope.hasNextPage()) { return; }
    var newPage = $scope.pagination.page + 1;
    $scope.pagination.goToPage(newPage);
  };

  $scope.hasNextPage = function() {
    if (!$scope.pagination) return;
    return ($scope.offsetStart + $scope.pagination.perPage) <=
      $scope.pagination.totalEntries;
  };

  $scope.previousPage = function() {
    if (!$scope.hasPreviousPage()) { return; }
    var newPage = $scope.pagination.page - 1;
    $scope.pagination.goToPage(newPage);
  };

  $scope.hasPreviousPage = function() {
    if (!$scope.pagination) return;
    return $scope.pagination.page > 1;
  };

  $scope.$watch('pagination.page', function(newVal, oldVal) {
    if (newVal && newVal != oldVal) {
      initializeVars();
    }
  });

  $scope.$watch('pagination.perPage', function(newVal, oldVal) {
    if (newVal && newVal != oldVal) {
      initializeVars();
    }
  });

  if (APP === 'admin') {
    hotkeys.add({
      combo: 'n n',
      description: 'Next Page',
      callback: function() { $scope.nextPage(); }
    });
    hotkeys.add({
      combo: 'p p',
      description: 'Previous Page',
      callback: function() { $scope.previousPage(); }
    });
  }
};

ctrl.$inject = ['$scope', 'hotkeys', 'APP'];

tiz.controller('PaginationSmallCtrl', ctrl);

var directive = function() {
  return {
    controller: 'PaginationSmallCtrl',
    templateUrl: require('../../templates/pagination/small.html'),
    scope: {
      pagination: '='
    }
  };
};

tiz.directive('paginationSmall', directive);
